import * as React from 'react';

export default () => (
  <svg width="16" height="16" fill="none">
    <path
      stroke="#B5BFD2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 6v6M9 2v10M13 9v3M1 1v14h14"
    />
  </svg>
);
